import '@app/App.css';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@comps/ui/dialog";
import { Workspace } from "@dto/workspaces";
import { BASE_URL } from '@utils/constants';
import { TW_WorkspaceMenuItem } from "@utils/twClasses";
import { put } from "@utils/utils";
import { Edit2 } from 'iconsax-react';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import WorkspaceForm, { CallBackEnd } from './WorkspaceForm';

interface WorkspaceMenuEditProps {
  workspace: Workspace;
  onWorkpaceUpdate: (workspace: Workspace) => void;
  closeMenu: () => void;
}

function WorkspaceMenuEditItem({ workspace, onWorkpaceUpdate, closeMenu }: WorkspaceMenuEditProps) {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const workspaceUpdated = (workspace: Workspace) => {
    setIsDialogOpen(false);
    closeMenu();
    onWorkpaceUpdate(workspace);
  }

  function cancel(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    setIsDialogOpen(false);
    closeMenu();
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsDialogOpen(true);
  }

  const updateWorkspaceCall: CallBackEnd<Workspace> = (body: any) => {
    return put<Workspace>(`${BASE_URL}/model/workspaces`, body);
  }

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger className={TW_WorkspaceMenuItem} onClick={handleClick}><Edit2 className="WorkspaceMenuItemIcon" />{t("workspace.button.edit.text")}</DialogTrigger>
      <DialogContent onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>{t("workspace.dialog.edit.title")}</DialogTitle>
          <DialogDescription className="hidden">{t("workspace.dialog.edit.description")}</DialogDescription>
        </DialogHeader>
        <WorkspaceForm initialWorkspace={workspace} callBackEnd={updateWorkspaceCall} onValidate={workspaceUpdated} onCancel={cancel} />
      </DialogContent>
    </Dialog>
  )
}


export default WorkspaceMenuEditItem;
